import React from 'react'
import { useSelector } from 'react-redux'

import { CreditsPanel } from 'components'
import { usePatientEligibility } from 'hooks/usePatientEligibility'
import { usePatientPlanType } from 'hooks/usePatientPlanType'
import { UserData } from 'models/Auth'

interface ICreditsPanel {
  creditsPanel: {
    data: { 
      available_credits: number
    }
  }
}

export function CreditsPanelWrapper() {
  const {
    isEnterprise,
    isCapitation,
    isCorporate,
    hasButton,
    setHasButton,
    planGroupName,
    creditsStatus,
    maxCredits,
    enableDetails,
    validDate,
    expired,
    errorButton,
    loadingButton,
    solicitationDate,
    isUnlimited,
    startDate,
    corporateEligibility,
    loading: loadingEligibility,
    forceUpdate,
    isCareplus,
    isCassi,
    planGroupCode,
    reasonCode,
    creditsPanelErrorMessage,
    patientPlans,
  } = usePatientEligibility(true)
  
  const { isParticular } = usePatientPlanType()

  const userData = useSelector((state: UserData) => state.auth.userData)
  const isAuth = useSelector((state: UserData) => state.auth.isAuth)
  const planSelected = useSelector((state: UserData) => state?.auth?.profileSelected?.plans.find(pPlan => pPlan.default === true))
  const creditsPanel = useSelector((state: ICreditsPanel) => state.creditsPanel.data)
  const availableCredits = creditsPanel.available_credits
  const hideCreditsPanel = !isAuth || isParticular
  const renderCreditsPanel = () => {
    if (hideCreditsPanel) return

    return (
      <CreditsPanel
        isEnterprise={isEnterprise}
        isCorporate={isCorporate}
        isPsiqProfile={false}
        professionalProfileRole="PSIC"
        isProfessionalProfile={true}
        isCareplus={isCareplus}
        isCassi={isCassi}
        isCapitation={isCapitation}
        hasButton={hasButton}
        setHasButton={setHasButton}
        planGroupName={planGroupName}
        creditsStatus={creditsStatus}
        availableCredits={availableCredits}
        maxCredits={maxCredits}
        enableDetails={enableDetails}
        validDate={validDate}
        expired={expired}
        errorButton={errorButton}
        loadingButton={loadingButton}
        solicitationDate={solicitationDate}
        isUnlimited={isUnlimited}
        startDate={startDate}
        corporateEligibility={corporateEligibility}
        loading={loadingEligibility}
        planGroupCode={planGroupCode}
        reasonCode={reasonCode}
        planCode={planSelected?.partner_plan_code}
        creditsPanelErrorMessage={creditsPanelErrorMessage}
        username={userData?.username}
        forceUpdate={forceUpdate}
        psychiatryEligibilityLoading={null}
        psychiatryEligibility={null}
        onClickRequestCreditsButton={null}
        onRequestTreatement={null}
        patientPlans={patientPlans}
      />
    )
  }

  return (
    <div>
      {renderCreditsPanel()}
    </div>
  )
}